export default "__VITE_ASSET__efb1c037__"